import { render, staticRenderFns } from "./DataSalesCallCenter.vue?vue&type=template&id=8f3f0054&scoped=true"
import script from "./DataSalesCallCenter.vue?vue&type=script&lang=js"
export * from "./DataSalesCallCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3f0054",
  null
  
)

export default component.exports